// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div:has(.Access-Management-Layout) {
    background: #f3f5f8;
    padding-bottom: 10px;
}

@media screen and(max-width:800px) {
    .Access-Management-Layout {
        /* overflow-x: scroll; */
    }
}

.cardHeading1 {
    padding-top: 20px;
    /* color: #0A3575; */
    text-align: center;
    font-family: 'Montserrat';
    font-size: 30px;
    font-style: normal;
    font-weight: 600;
    line-height: 120%;
}

.cardHeading2 {
    /* color: #0A3575; */
    text-align: center;
    font-family: 'Montserrat';
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%;
    padding-top: 10px;
}

.roleEditHead {
    background-color: #0E2B63;
    border-radius: 6px 6px 0px 0px;
    height: 43px;
    flex-shrink: 0;
    justify-content: space-between !important;
    display: flex;
    padding: 0px 32px;
    align-items: center;
}

.roleEditHeader {
    color: #FFF;
    font-family: 'Montserrat';
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 163%;
    /* 22.82px */
}

.editroletab {
    color: #FFF;
    font-family: 'Montserrat' !important;
    font-size: 14px !important;
    font-style: normal;
    font-weight: 600;
    padding: 0px !important;
    text-transform: none !important;
    /* 22.82px */
}

.roleAssignHeader {
    color: #191E31;
    padding: 17px 0px 14px 0px;
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    text-align: center;
    font-weight: 700;
    line-height: 163%;
    /* 29.34px */
}

.roleAssignHeader2 {
    /* padding: 23px 0px 20px 0px; */
    color: #191E31;
    text-align: center;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    line-height: 150%;
    /* 24px */
}

.roleAssignTable {
    color: #FFF;
    text-align: center;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
    padding:0px 67px
    /* 21px */
}

.editroletab {
    /* color: #191E31;
font-family: 'Montserrat';
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 163%; 22.82px */
}

.roleAssignTableModule {
    color: #191E31;
    font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 163%;
    /* 22.82px */
}
.roleAssignTableSubModule{
    color: #191E31;
font-family: Montserrat;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 163%; /* 22.82px */
}`, "",{"version":3,"sources":["webpack://./src/components/pages/AccessManagement/RoleAssign/RoleAssign.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,YAAY;IACZ,cAAc;IACd,yCAAyC;IACzC,aAAa;IACb,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,0BAA0B;IAC1B,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,+BAA+B;IAC/B,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,0BAA0B;IAC1B,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,SAAS;AACb;;AAEA;IACI;;;;;4BAKwB;AAC5B;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;AACA;IACI,cAAc;AAClB,uBAAuB;AACvB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,YAAY;AAC/B","sourcesContent":["div:has(.Access-Management-Layout) {\n    background: #f3f5f8;\n    padding-bottom: 10px;\n}\n\n@media screen and(max-width:800px) {\n    .Access-Management-Layout {\n        /* overflow-x: scroll; */\n    }\n}\n\n.cardHeading1 {\n    padding-top: 20px;\n    /* color: #0A3575; */\n    text-align: center;\n    font-family: 'Montserrat';\n    font-size: 30px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 120%;\n}\n\n.cardHeading2 {\n    /* color: #0A3575; */\n    text-align: center;\n    font-family: 'Montserrat';\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 120%;\n    padding-top: 10px;\n}\n\n.roleEditHead {\n    background-color: #0E2B63;\n    border-radius: 6px 6px 0px 0px;\n    height: 43px;\n    flex-shrink: 0;\n    justify-content: space-between !important;\n    display: flex;\n    padding: 0px 32px;\n    align-items: center;\n}\n\n.roleEditHeader {\n    color: #FFF;\n    font-family: 'Montserrat';\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 163%;\n    /* 22.82px */\n}\n\n.editroletab {\n    color: #FFF;\n    font-family: 'Montserrat' !important;\n    font-size: 14px !important;\n    font-style: normal;\n    font-weight: 600;\n    padding: 0px !important;\n    text-transform: none !important;\n    /* 22.82px */\n}\n\n.roleAssignHeader {\n    color: #191E31;\n    padding: 17px 0px 14px 0px;\n    font-family: Montserrat;\n    font-size: 18px;\n    font-style: normal;\n    text-align: center;\n    font-weight: 700;\n    line-height: 163%;\n    /* 29.34px */\n}\n\n.roleAssignHeader2 {\n    /* padding: 23px 0px 20px 0px; */\n    color: #191E31;\n    text-align: center;\n    font-family: Montserrat;\n    font-size: 16px;\n    font-style: normal;\n    line-height: 150%;\n    /* 24px */\n}\n\n.roleAssignTable {\n    color: #FFF;\n    text-align: center;\n    font-family: Montserrat;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%;\n    padding:0px 67px\n    /* 21px */\n}\n\n.editroletab {\n    /* color: #191E31;\nfont-family: 'Montserrat';\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 163%; 22.82px */\n}\n\n.roleAssignTableModule {\n    color: #191E31;\n    font-family: Montserrat;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 163%;\n    /* 22.82px */\n}\n.roleAssignTableSubModule{\n    color: #191E31;\nfont-family: Montserrat;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 163%; /* 22.82px */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
